export class QueryCondition
{
    constructor(
        )
    {}
}
